<template>
  <div>
    <div class="p-3 card mb-3">
      <fccOpcaoBusca :lista-apresentacao-das-opcoes="listaApresentacaoDasOpcoes" @buscar="buscar" />
    </div>

    <div class="p-3 card mb-3" v-if="listaOpcoes.length > 0 || listaAlteracoes.length > 0">
      <fccOpcaoTabela
        :lista-opcoes="listaOpcoes"
        @importar="importar"
        v-if="listaOpcoes.length > 0"
      />
      <fccOpcaoAlteracoes
        :lista-alteracoes="listaAlteracoes"
        @deletar="deletar"
        v-if="listaAlteracoes.length > 0"
      />
    </div>

    <fccLocalDeProvaStatus :etapa="etapa" />
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../../../store'
import fccOpcaoBusca from './fccOpcaoBusca.vue'
import fccOpcaoTabela from './fccOpcaoTabela.vue'
import fccOpcaoAlteracoes from './fccOpcaoAlteracoes.vue'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import { TP_ETAPA } from '../constantes'

export default {
  components: {
    fccOpcaoBusca,
    fccOpcaoTabela,
    fccOpcaoAlteracoes,
    fccLocalDeProvaStatus
  },
  data() {
    return {
      listaApresentacaoDasOpcoes: [],
      listaOpcoes: [],
      listaAlteracoes: [],
      tpApresentacao: '',
      rotulo: ''
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    etapa() {
      return TP_ETAPA.OPCAO
    }
  },
  created() {
    this.carregaTexto(this.codeMensagem('C01'))
    this.listarApresentacaoDasOpcoes().then(() => this.listarAlteracoes().then(this.carregaTexto))
  },
  methods: {
    listarApresentacaoDasOpcoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameTipoApresentacaoOpcao/ListaTpApresentacaoOpcao`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaApresentacaoDasOpcoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    buscar(tpApresentacao, rotulo) {
      this.tpApresentacao = tpApresentacao
      this.rotulo = rotulo

      this.carregaTexto(this.codeMensagem('C01'))
      this.listarOpcoes().then(this.carregaTexto)
    },
    listarOpcoes() {
      const payload = {
        idLocalConfig: this.configuracao.idlocalconfig,
        tipoApresentacao: this.tpApresentacao,
        rotulo: this.rotulo
      }

      return new Promise((resolve) => {
        axios
          .post(
            store.state.baseUrlLocalDeProva +
              `LocalExameTipoApresentacaoOpcao/ListaApresentacaoOpcao/`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaOpcoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    importar(items) {
      const body = items.map((item) => ({
        idLocalOpcao: 0,
        tpApresentacaoOpcao: item.tpapresentacao,
        idLocalConfig: this.configuracao.idlocalconfig,
        codCargo: item.codigo,
        cargo: item.opcao,
        rotulo: item.rotulo,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          store.state.baseUrlLocalDeProva +
            `LocalExameTipoApresentacaoOpcao/InserirApresentacaoOpcao`,
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => this.listarOpcoes().then(() => this.listarAlteracoes().then(this.carregaTexto)))
        .catch(this.setErrorSystem)
    },
    listarAlteracoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameTipoApresentacaoOpcao/ListaApresentacaoOpcaoCadastrado/${this.configuracao.idlocalconfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaAlteracoes = data.map((item) => ({
              opcao: item.codcargo + ' - ' + item.cargo,
              ...item
            }))
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    deletar(items) {
      const payload = items.map((item) => ({
        idLocalOpcao: item.idlocalopcao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.callConfirm(`Tem certeza que deseja excluir?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .delete(
            store.state.baseUrlLocalDeProva +
              `LocalExameTipoApresentacaoOpcao/ExcluiTipoApresentacaoOpcaoCadastrado`,
            { data: payload },
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarAlteracoes().then(() => {
              if (this.listaOpcoes.length > 0) this.listarOpcoes().then(this.carregaTexto)
              else this.carregaTexto()
            })
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>